var map = {
	"./bitcoin.svg": 6466,
	"./cardano.svg": 597,
	"./cash_back.svg": 7075,
	"./comeback.svg": 7994,
	"./doge.svg": 6940,
	"./polygon.svg": 645,
	"./ripple.svg": 2164,
	"./shiba.svg": 6023,
	"./stellar.svg": 9107,
	"./tether.svg": 9197,
	"./tezos.svg": 5308,
	"./trading_voucher.svg": 3078,
	"./tron.svg": 2854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1563;